import _ from "lodash";
import React from "react";
import classes from "./ClickableHighlightedText.scss";
import PropTypes from "prop-types";

const ClickableHighlightedText = props => {
  const content = _.get(props, "children", "");

  const onClickText = () => {
    if (_.isFunction(props.onClick)) {
      props.onClick?.({ ...props });
    }
  };
  return (
    <span
      role="button"
      tabIndex={0}
      className={classes.highlightedPoint}
      onClick={onClickText}
      onKeyPress={onClickText}
    >
      {content}
    </span>
  );
};

ClickableHighlightedText.propTypes = {
  type: PropTypes.string,
  content: PropTypes.elementType,
  onClick: PropTypes.func,
};

ClickableHighlightedText.defaultProps = {
  content: "",
};

export default ClickableHighlightedText;
